import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

/** Bordered shell around a data table, with optional header strip and footer. */
export default function TableCard({ title, actions, header, children, footer, sx }) {
  return (
    <Paper
      sx={{
        background: 'var(--card)',
        border: '1px solid var(--border)',
        borderRadius: 'var(--radius)',
        boxShadow: 'var(--shadow)',
        overflow: 'hidden',
        ...sx,
      }}
    >
      {(title || actions) && (
        <Box
          sx={{
            p: '15px 18px',
            display: 'flex',
            gap: 1.5,
            alignItems: 'center',
            flexWrap: 'wrap',
            borderBottom: '1px solid var(--border)',
          }}
        >
          {title && (
            <Typography variant="h6" sx={{ fontSize: 15, fontWeight: 600, flex: 'none' }}>
              {title}
            </Typography>
          )}
          <Box sx={{ flex: 1 }} />
          {actions}
        </Box>
      )}
      {header}
      {/* horizontal scroll stays inside the card — the page never scrolls sideways */}
      <Box sx={{ overflowX: 'auto' }}>{children}</Box>
      {footer && (
        <Box
          sx={{
            p: '12px 18px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 1.5,
            flexWrap: 'wrap',
            color: 'var(--ink-2)',
            fontSize: 12.5,
          }}
        >
          {footer}
        </Box>
      )}
    </Paper>
  );
}

/** Empty-state row that spans the whole table. */
export function EmptyRow({ colSpan, children = 'No matching records' }) {
  return (
    <tr>
      <td colSpan={colSpan} style={{ textAlign: 'center', color: 'var(--muted)', padding: 26 }}>
        {children}
      </td>
    </tr>
  );
}
